var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24.000000pt",
    height: "24.000000pt",
    viewBox: "0 0 24.000000 24.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,24.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 194 c-3 -9 -1 -25 6 -35 8 -15 8 -23 0 -38 -7 -10 -9 -26 -6 -35 9 -24 185 -24 194 0 3 9 1 25 -6 35 -8 15 -8 23 0 38 7 10 9 26 6 35 -9 24 -185 24 -194 0z m177 -9 c0 -3 -6 -14 -12 -25 -10 -16 -10 -24 0 -40 6 -11 12 -22 12 -25 0 -3 -36 -5 -80 -5 -44 0 -80 2 -80 5 0 3 6 14 12 25 10 16 10 24 0 40 -6 11 -12 22 -12 25 0 3 36 5 80 5 44 0 80 -2 80 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 34 c49 -12 62 -12 72 -2 11 11 0 13 -59 15 l-72 1 59 -14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/tickets.eacc019d6a10cf1b76461471d6a48269.svg";
export { ForwardRef as ReactComponent };